<template>
  <transition
    name="fade-transform"
    @after-leave="afterLeave"
    @before-enter="beforeEnter"
  >
    <div
      v-show="visible"
      class="jin-picker-panel"
      :class="[`placement-${placement}`]"
      @click.stop=""
    >
      <div class="jin-picker-panel__body">
        <div class="jin-date-picker__header">
          <div class="jin-date-picker__toggle">
            <button
              class="jin-date-picker__prev-btn jin-picker-panel__icon-btn"
              @click="prevYear"
            >
              <span class="ushk-icon ushk-icon_triangle"></span>
            </button>
            <!-- <button
              class="jin-date-picker__prev-btn jin-picker-panel__icon-btn"
              @click="prevMonth"
            ></button> -->
            <span class="jin-date-picker__header-label">
              {{ yearLabel }}
            </span>
            <span class="jin-date-picker__header-label">
              {{ monthLabel }}
            </span>
            <span class="jin-date-picker__header-label">
              {{ dayLabel }}
            </span>
            <!-- <button
              class="jin-date-picker__next-btn jin-picker-panel__icon-btn"
              @click="nextMonth"
            ></button> -->
            <button
              class="jin-date-picker__next-btn jin-picker-panel__icon-btn"
              @click="nextYear"
            >
              <span class="ushk-icon ushk-icon_triangle"></span>
            </button>
          </div>
          <!-- <div class="jin-date-picker__range">
            <button
              v-for="range in ranges"
              :key="range.value"
              class="jin-date-picker__range-btn"
              :class="{
                'is-active': selectionMode === range.value
              }"
              @click="range.onClick"
            >
              {{ range.label }}
            </button>
          </div> -->
        </div>

        <div class="jin-picker-panel__content">
          <jin-date-table
            v-show="selectionMode === 'day' || selectionMode === 'week'"
            :date="date"
            :initDate="initDate"
            :selection-mode="selectionMode"
            :first-day-of-week="firstDayOfWeek"
            @pick="handleDatePick"
          />
          <jin-month-table
            v-show="selectionMode === 'month'"
            :date="date"
            :selection-mode="selectionMode"
            @pick="handleMonthPick"
          />
        </div>
      </div>

      <div class="jin-picker-panel__footer">
        <div class="jin-picker-panel__months">
          <span
            v-for="i in 12"
            :key="i"
            :class="{
              active: i === month + 1,
              current: i === actualMonth + 1 && actualCurrentYear === year
            }"
            @click.self.stop="onChangeMonth(i)"
          >
            {{ i }}月
          </span>
        </div>

        <!-- <button class="jin-picker-panel__footer-btn" @click="handleBackToCurrent">
          {{ backToCurrentLabel }}
        </button> -->
        <!-- <button class="jin-picker-panel__footer-btn" @click="handleSubmit">
          确定
        </button> -->
      </div>
    </div>
  </transition>
</template>

<script>
import {
  prevYear,
  nextYear,
  prevMonth,
  nextMonth,
  modifyDate,
  getWeekNumber,
  prevDate,
  nextDate,
  getWeekOfMonth,
  getEndWeekOfLastMonth,
} from '@/commons/utils/date-util'
import JinMonthTable from './JinMonthTable'
import JinDateTable from './JinDateTable'

const DATE_FORMATS = {
  day: 'yyyy-MM-dd',
  week: 'yyyy-MM',
  month: 'yyyy-MM',
}

const WEEK_ORDERS = ['一', '二', '三', '四', '五']

export default {
  name: 'JinDatePickerPanel',

  model: {
    prop: 'visible',
    event: 'change',
  },
  components: {
    JinMonthTable,
    JinDateTable,
  },
  props: {
    initDate: {
      type: Date,
      default() {
        return this.date
      }
    },
    placement: {
      type: String,
      default: 'left',
    },
    visible: Boolean,
    hideAfterSubmit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      actualCurrentYear: new Date().getFullYear(),
      firstDayOfWeek: 1,
      value: '',
      date: new Date(),
      selectionMode: 'day',
      shortcuts: [
        {
          text: '本周',
          type: 'week',
          shortcut: 'currentWeek',
          onClick: () => {
            this.handleShortcutClick('currentWeek')
          },
        },
        {
          text: '上周',
          type: 'week',
          shortcut: 'lastWeek',
          onClick: () => {
            this.handleShortcutClick('lastWeek')
          },
        },
        {
          text: '下周',
          type: 'week',
          shortcut: 'nextWeek',
          onClick: () => {
            this.handleShortcutClick('nextWeek')
          },
        },
        {
          text: '本月',
          type: 'month',
          shortcut: 'currentMonth',
          onClick: () => {
            this.handleShortcutClick('currentMonth')
          },
        },
        {
          text: '上月',
          type: 'month',
          shortcut: 'lastMonth',
          onClick: () => {
            this.handleShortcutClick('lastMonth')
          },
        },
        {
          text: '下月',
          type: 'month',
          shortcut: 'nextMonth',
          onClick: () => {
            this.handleShortcutClick('nextMonth')
          },
        },
      ],
      ranges: [
        {
          label: '月',
          value: 'month',
          onClick: () => {
            this.showMonthPicker()
          },
        },
        {
          label: '周',
          value: 'week',
          onClick: () => {
            this.showWeekPicker()
          },
        },
        {
          label: '日',
          value: 'day',
          onClick: () => {
            this.showDayPicker()
          },
        },
      ],
    }
  },
  computed: {
    offsetDay() {
      const week = this.firstDayOfWeek
      // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
      return week > 3 ? 7 - week : -week
    },
    year() {
      return this.date.getFullYear()
    },
    month() {
      return this.date.getMonth()
    },
    day() {
      return this.date.getDate()
    },
    week() {
      return getWeekNumber(this.date)
    },
    yearLabel() {
      return this.year + '年'
    },
    monthLabel() {
      const { month } = this
      return String(month + 1).length < 2 ? `0${month + 1}月` : `${month + 1}月`
    },
    dayLabel() {
      const { day } = this
      return String(day + 1).length < 2 ? `0${day}日` : `${day}日`
    },
    backToCurrentLabel() {
      return {
        day: '回到今日',
        week: '回到本周',
        month: '回到本月',
      }[this.selectionMode]
    },
    actualMonth() {
      return new Date().getMonth()
    }
  },
  methods: {
    onChangeMonth(month) {
      if (month === 1) {
        this.date = nextMonth(new Date(`${this.year - 1}/12/${this.day}`))
        return
      }

      this.date = nextMonth(new Date(`${this.year}/${month - 1}/${this.day}`))
    },

    show() {
      this.$emit('change', true)
    },
    hide() {
      this.$emit('change', false)
    },

    showMonthPicker() {
      this.selectionMode = 'month'
    },
    showWeekPicker() {
      this.selectionMode = 'week'
    },
    showDayPicker() {
      this.selectionMode = 'day'
    },

    prevYear() {
      this.date = prevYear(this.date)
    },
    nextYear() {
      this.date = nextYear(this.date)
    },
    prevMonth() {
      this.date = prevMonth(this.date)
    },
    nextMonth() {
      this.date = nextMonth(this.date)
    },
    handleMonthPick(month) {
      this.date = modifyDate(this.date, this.year, month, 1)
      this.handleSubmit()
    },
    handleDatePick(value) {
      this.date = new Date(value)
      this.handleSubmit()
    },
    handleBackToCurrent() {
      this.date = new Date()
      this.handleSubmit()
    },
    handleShortcutClick(shortcut) {
      const currentDate = new Date()
      const handler = {
        currentWeek: () => {
          this.selectionMode = 'week'
          this.date = currentDate
        },
        lastWeek: () => {
          this.selectionMode = 'week'
          this.date = prevDate(currentDate, 7)
        },
        nextWeek: () => {
          this.selectionMode = 'week'
          this.date = nextDate(currentDate, 7)
        },
        currentMonth: () => {
          this.selectionMode = 'month'
          this.date = currentDate
        },
        lastMonth: () => {
          this.selectionMode = 'month'
          this.date = prevMonth(currentDate)
        },
        nextMonth: () => {
          this.selectionMode = 'month'
          this.date = nextMonth(currentDate)
        },
      }[shortcut]
      handler && handler()
      this.$nextTick(() => {
        this.handleSubmit()
      })
    },
    getShortcutActive({ shortcut, type }) {
      if (this.selectionMode !== type) {
        return false
      }
      const currentDate = new Date()
      const currentMonth = currentDate.getMonth()
      const currentYear = currentDate.getFullYear()
      const valid = {
        currentWeek: () =>
          this.week === getWeekNumber(currentDate) && this.year === currentYear,
        lastWeek: () =>
          this.week === getWeekNumber(prevDate(currentDate, 7)) &&
          this.year === currentYear,
        nextWeek: () =>
          this.week === getWeekNumber(nextDate(currentDate, 7)) &&
          this.year === currentYear,
        currentMonth: () =>
          this.month === currentMonth && this.year === currentYear,
        lastMonth: () =>
          currentMonth === 0
            ? this.month === 11 && this.year === currentYear - 1
            : this.month === currentMonth - 1 && this.year === currentYear,
        nextMonth: () =>
          currentMonth === 11
            ? this.month === 0 && this.year === currentYear + 1
            : this.month === currentMonth + 1 && this.year === currentYear,
      }[shortcut]
      return valid()
    },
    handleSubmit() {
      const weekDays = []
      if (this.selectionMode === 'week') {
        const weekDay = this.date.getDay()
        const weekStartDate = prevDate(
          this.date,
          weekDay === 0 ? 6 : weekDay - 1,
        )
        for (let i = 0; i < 7; i++) {
          weekDays.push(nextDate(weekStartDate, i))
        }
      }

      const weekOfMonth = getWeekOfMonth(this.date)
      /** 上个月最后一周是上个月的第几周 */
      const lastMonthEndWeek = getEndWeekOfLastMonth(this.date)
      const weekOfMonthObj = {
        date: weekOfMonth <= 0 ? prevMonth(this.date) : this.date,
        order: weekOfMonth <= 0 ? lastMonthEndWeek : weekOfMonth,
        month: weekOfMonth <= 0 ? prevMonth(this.date).getMonth() : this.month,
      }
      const { date } = this
      const label = {
        day: () => date.format(DATE_FORMATS.day),
        week: () =>
          `${weekOfMonthObj.date.format(DATE_FORMATS.week)} 第${
            WEEK_ORDERS[weekOfMonthObj.order - 1]
          }周`,
        month: () => date.format(DATE_FORMATS.month),
      }[this.selectionMode]()
      const value = {
        week: this.week,
        year: this.year,
        month: this.month,
        date: this.date,
        mode: this.selectionMode,
        weekDays,
        weekOfMonth: weekOfMonthObj,
        label,
      }
      this.hideAfterSubmit && this.hide()
      this.$emit('pick', value)
    },

    setSelectionMode(mode) {
      this.selectionMode = mode
    },
    setDate(date) {
      this.date = date
    },
    pick() {
      this.handleSubmit()
    },
    beforeEnter() {
      this.$emit('open')
    },
    afterLeave() {
      this.$emit('closed')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/styles/helpers/_function.scss";

$picker: '.jin-date-picker';

.jin-picker-panel {
  z-index: 11;
  position: absolute;
  top: calc(100% + 10px);
  // width: 450px;
  background-color: #1b1b1b;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  font-size: 16px;
  color: $thirdText;
  overflow: hidden;
  user-select: none;
  &.placement-left {
    right: 0;
  }
  &.placement-right {
    left: 0;
  }
  &.placement-center {
    left: 50%;
    margin-left: -154px;
  }
  &__sidebar {
    padding: 10px 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 82px;
    border-right: 1px solid #eee;
    box-sizing: border-box;
    text-align: center;
    &-title {
      line-height: 20px;
      margin-bottom: 20px;
    }
  }
  &__shortcut {
    margin: 0 auto;
    width: 57px;
    line-height: 24px;
    text-align: center;
    background-color: #f4f5f9;
    color: $primary;
    border-radius: 12px;
    transition: background 0.3s;
    &:hover {
      background-color: #e6e8ed;
    }
    cursor: pointer;
    &:not(:last-child) {
      margin-bottom: 18px;
    }
    &.is-active {
      color: #fff;
      background-color: $primary;
    }
  }
  #{$picker}__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid rgba(123, 123, 123, 0.6);
  }
  #{$picker}__toggle {
    padding: 0 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #{$picker}__range {
    margin-right: 20px;
    &-btn {
      padding: 0;
      width: 14px;
      height: 18px;
      line-height: 18px;
      font-size: 14px;
      border: none;
      // background: #fff;
      color: $thirdText;
      &:not(:first-child) {
        margin-left: 16px;
      }
      &:hover,
      &.is-active {
        color: $primary;
      }
    }
  }

  &__icon-btn {
    display: inline-block;
    padding: 0;
    // background: #fff;
    background-color: #1b1b1b;
    border: none;
    width: 16px;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    &:hover {
      span {
        color: $primary;
      }
    }
  }
  #{$picker}__prev-btn {
    margin-right: 20px;
    transform: rotate(90deg);
  }
  #{$picker}__header-label {
    font-size: 16px;
    color: $primary;
    font-weight: 600;
  }
  #{$picker}__next-btn {
    margin-left: 20px;
    transform: rotate(-90deg);
  }
  &__body {
    // margin-left: 82px;
  }
  &__content {
    height: 260px;
    padding: 12px;
  }
  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 10px;
    background: #1b1b1b;
    &-btn {
      width: 100%;
      height: 36px;
      font-size: 14px;
      color: $primary;
      background: #fff;
      border: none;
      transition: opacity 0.3s;
      &:first-child {
        // border-right: 1px solid #eee;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
  &__months {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(6, 16.666%);
    grid-template-rows: 50% 50%;
    row-gap: 5px;
    justify-items: center;

    span {
      display: inline-block;
      width: 44px;
      line-height: 24px;
      height: 26px;
      color: #979797;
      font-size: 16px;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #424141;
      background: #424141;
      cursor: pointer;
      transition: all .3s;

      &.active, &:hover {
        color: #fff !important;
        font-weight: bold;
        background-color: $primary;
        border: 1px solid $primary;
        border-radius: 4px;
      }

      &.current {
        color: $colorText;
      }
    }
  }
  @include max-screen(768px) {
    width: 320px;
    .jin-date-table {
      width: 100%;
    }
    &__body {
      margin-left: 0;
      display: flex;
      flex-direction: column;
    }
    &__sidebar {
      padding: 16px 22px 12px 22px;
      position: relative;
      width: 100%;
      border-right: none;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      text-align: left;
      &-title {
        color: $primary;
        font-weight: bold;
      }
    }
    &__shortcut-wrapper {
      display: flex;
      flex-wrap: wrap;
    }
    &__shortcut {
      margin: 0;
      margin-bottom: 16px;
      margin-right: 12px;
      &:nth-child(4n + 4) {
        margin-right: 0;
      }
    }
    &__footer {
      margin-left: 0;
    }
    &__months {
      row-gap: 6px;
      span {
        width: 42px;
        font-size: 14px;
        line-height: 28px;
        height: 30px;
      }
    }
  }

  @include max-screen(500px) {
    z-index: 10000000;
  }
}
</style>



// WEBPACK FOOTER //
// JinDatePickerPanel.vue?ff434c54